import React, { useCallback, useEffect, useRef, useState } from 'react'
import { GoogleMap, LoadScript } from '@react-google-maps/api'
import { MapMarkers } from './mapMarkers'

const containerStyle = {
  position: 'relative',
  width: '100%',
  height: '100%',
  zIndex: 0,
}

const initialLatLng = { lat: parseFloat('63.430515'), lng: parseFloat('10.395053') }

export const MapContainer = ({ workshops, zoom }) => {
  const mapRef = useRef()
  const [map, setMap] = useState(null)

  useEffect(() => {
    if (map) {
      const bounds = new window.google.maps.LatLngBounds()

      workshops.map((workshop) => {
        const latLng = new window.google.maps.LatLng({
          lat: parseFloat(workshop.lat),
          lng: parseFloat(workshop.long),
        })

        bounds.extend(latLng)

        return workshop.id
      })

      // Don't zoom too much if only one workshop
      if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
        const extendPoint1 = new window.google.maps.LatLng(
          bounds.getNorthEast().lat() + 0.05,
          bounds.getNorthEast().lng() + 0.05
        )

        const extendPoint2 = new window.google.maps.LatLng(
          bounds.getNorthEast().lat() - 0.05,
          bounds.getNorthEast().lng() - 0.05
        )
        bounds.extend(extendPoint1)
        bounds.extend(extendPoint2)
      }

      map.fitBounds(bounds, 0)
    }
  }, [map, mapRef, workshops, zoom])

  const onLoad = useCallback((map) => {
    setMap(map)
  }, [])

  const onUnmount = useCallback((map) => {
    setMap(null)
  }, [])

  return (
    <LoadScript googleMapsApiKey="AIzaSyDpI6vnJNMOxeT6UqOY37-jy66m9ajkzyY">
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={initialLatLng}
        zoom={zoom}
        onLoad={onLoad}
        onUnmount={onUnmount}
        ref={mapRef}
      >
        <MapMarkers workshops={workshops} />
      </GoogleMap>
    </LoadScript>
  )
}

export default React.memo(MapContainer)
